import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { TrendingUp, Users, Briefcase, Star } from "lucide-react";

// Format an INR amount as ₹__ L (Lakh) or ₹__ Cr (Crore) depending on scale.
function formatInrShort(n) {
  if (n >= 1_00_00_000) return `₹${(n / 1_00_00_000).toFixed(2)} Cr`;
  if (n >= 1_00_000) return `₹${(n / 1_00_000).toFixed(1)} L`;
  return `₹${n.toLocaleString("en-IN")}`;
}

export default function StatsBar() {
  // Early-traction defaults — must match backend `/api/stats` shape and stay
  // believable for a young platform (Lakhs, not Crores).
  const [s, setS] = useState({
    total_earnings_inr: 19_82_000,
    active_agents: 100,
    jobs_completed: 429,
    avg_rating: 4.87,
  });

  useEffect(() => {
    api.get("/stats").then((r) => setS(r.data)).catch(() => {});
  }, []);

  const items = [
    { icon: TrendingUp, label: "Paid to freelancers", value: formatInrShort(s.total_earnings_inr), tone: "text-emerald-600" },
    { icon: Users, label: "Active agents", value: s.active_agents.toLocaleString("en-IN"), tone: "text-blue-600" },
    { icon: Briefcase, label: "Gigs completed", value: s.jobs_completed.toLocaleString("en-IN"), tone: "text-slate-900" },
    { icon: Star, label: "Avg rating", value: s.avg_rating.toFixed(2), tone: "text-yellow-500" },
  ];

  return (
    <section data-testid="stats-bar" className="border-y border-slate-200 bg-white/70 backdrop-blur">
      <div className="mx-auto max-w-7xl px-5 md:px-8 py-6 grid grid-cols-2 md:grid-cols-4 gap-6">
        {items.map((it) => (
          <div key={it.label} className="flex items-center gap-3">
            <span className={`grid place-items-center w-10 h-10 rounded-lg bg-slate-50 border border-slate-200 ${it.tone}`}>
              <it.icon size={18} />
            </span>
            <div>
              <p className="font-display font-bold text-slate-900 text-xl leading-tight">{it.value}</p>
              <p className="text-xs text-slate-500 uppercase tracking-wider">{it.label}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
